<template>
    <div>

        <div class="row">
            <div class="col-sm-2 col-xs-12">
                <div class="form-group">
                    <label class="generic-label">Reason</label>
                    <bootstrap-select class="form-control"
                                      v-model="call.Reason"
                                      :options="reasonOptions"
                                      :readonly="readOnly"
                    ></bootstrap-select>
                </div>
            </div>

            <div class="col-sm-3 col-xs-12">
                <div class="form-group" :class="{required: requiredFields.VehiclePlate === true, error: fieldErrors.VehiclePlate.length > 0}">
                    <label class="generic-label" for="txtVehiclePlate">
                        Plate/Tag
                        <span v-if="selectedProvince"> - {{selectedProvince.text}}</span>
                    </label>

                    <div class="input-group">
                        <input id="txtVehiclePlate" name="txtVehiclePlate" maxlength="10" type="text" placeholder="Plate/Tag" class="form-control generic-input" v-model="call.VehiclePlate" :readonly="readOnly" v-uppercase>
                        <div class="input-group-btn">
                            <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :disabled="readOnly">
                                <span class="caret"></span>
                                <span class="sr-only">State for plate lookup</span>
                            </button>
                            <ul class="dropdown-menu">
                                <li v-for="province in provinceOptions"><a href="#" @click.prevent="changeProvince(province)">{{province.text}}</a></li>
                            </ul>
                            <button class="btn btn-default" @click="plateLookup()" :disabled="readOnly"><i class="fas fa-search"></i></button>
                        </div>
                    </div>

                    <div class="error" v-if="fieldErrors.VehiclePlate.length > 0">
                        <p v-for="error in fieldErrors.VehiclePlate">{{error}}</p>
                    </div>
                </div>
            </div>

            <div class="col-sm-2 col-xs-12">
                <div class="form-group">
                    <label class="generic-label" for="cboVehicleMake">Vehicle Make</label>
                    <bootstrap-select class="form-control" v-model="call.VehicleMake" :options="vehicleMakeOptions" :readonly="readOnly"></bootstrap-select>
                </div>
            </div>
            <div class="col-sm-2 col-xs-12">
                <!-- In the clients system you select the make first and then the options appear for model. -->
                <div class="form-group">
                    <label class="generic-label" for="cboVehicleModel">Vehicle Model</label>
                    <bootstrap-select class="form-control" v-model="call.VehicleModel" :options="vehicleModelOptions" :disabled="call.VehicleMake == null" :readonly="readOnly"></bootstrap-select>
                </div>
            </div>

            <div class="col-sm-2 col-xs-12">
                <div class="form-group">
                    <label class="generic-label" for="cboVehicleColor">Vehicle Color</label>
                    <bootstrap-select class="form-control" v-model="call.VehicleColor" :options="colorOptions" :readonly="readOnly"></bootstrap-select>
                </div>
            </div>

            <div class="col-sm-1 col-xs-12">
                <div class="form-group">
                    <label class="generic-label" for="txtVehicleYear">Year</label>
                    <input id="txtVehicleYear" name="txtVehicleYear" maxlength="4" type="text" placeholder="Year" class="form-control generic-input" v-model="call.VehicleYear" :readonly="readOnly">
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col-sm-2 col-xs-12">
                <div class="form-group">
                    <label class="generic-label" for="txtVehicleOdometer">Odometer</label>
                    <input id="txtVehicleOdometer" name="txtVehicleOdometer" maxlength="7" type="text" placeholder="Odometer" class="form-control generic-input" v-model="call.Odometer" :readonly="readOnly">
                </div>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <div class="form-group" :class="{required: requiredFields.VIN === true, error: fieldErrors.VIN.length > 0}">
                    <label class="generic-label" for="txtVIN">VIN</label>
                    <div class="input-group">
                        <input id="txtVIN" name="txtVIN" type="text" maxlength="25" placeholder="VIN" class="form-control generic-input" v-model="call.VIN" :readonly="readOnly" v-uppercase>
                        <span class="input-group-btn">
                            <button type="button" class="btn btn-default" @click="vinLookup"><i class="fas fa-search"></i></button>
                        </span>
                    </div>
                    <div class="error" v-if="fieldErrors.VIN.length > 0">
                        <p v-for="error in fieldErrors.VIN">{{error}}</p>
                    </div>
                </div>
            </div>

            <div class="col-sm-2 col-xs-12">
                <div class="form-group">
                    <label class="generic-label" for="txtTruckNumber">Truck #</label>
                    <input id="txtTruckNumber" name="txtTruckNumber" maxlength="10" type="text" placeholder="Truck #" class="form-control generic-input" v-model="call.TruckNumber" :readonly="readOnly">
                </div>
            </div>

            <div class="col-sm-2 col-xs-12">
                <div class="form-group">
                    <label class="generic-label" for="txtTrailerNumber">Trailer #</label>
                    <input id="txtTrailerNumber" name="txtTrailerNumber" maxlength="10" type="text" placeholder="Trailer #" class="form-control generic-input" v-model="call.TrailerNumber" :readonly="readOnly">
                </div>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <div class="form-group">
                    <label class="generic-label" for="txtVehicleKeys">Key Location</label>
                    <input id="txtVehicleKeys" name="txtVehicleKeys" maxlength="25" type="text" placeholder="Key Location" class="form-control generic-input" v-model="call.KeyLocation" :readonly="readOnly">
                </div>
            </div>

        </div>
    </div>
</template>

<style lang="scss" scoped>

    .input-group-btn > button {
        border-radius: 0px;

        &:last-child {
            border-radius: 0px 4px 4px 0px;
        }

        .caret {
            margin-left: -16px;
        }

    }

</style>

<script>
    export default {

        props: {
            call: Object,
            requiredFields: Object,
            fieldErrors: Object,
            readOnly: Boolean,
        },

        data() {
            return {

                selectedProvince: null,

                vehicleMakes: window.vehicleMakes ? window.vehicleMakes : [],

                reasonOptions: [
                    { value: null, text: '- Select a Reason -', disabled: true },
                    { value: 'Abandoned', text: 'Abandoned' },
                    { value: 'Accident', text: 'Accident' },
                    { value: 'Breakdown', text: 'Breakdown' },
                    { value: 'Flat Tire', text: 'Flat Tire' },
                    { value: 'Fuel Delivery', text: 'Fuel Delivery' },
                    { value: 'Illegal Parking', text: 'Illegal Parking' },
                    { value: 'Jump Start', text: 'Jump Start' },
                    { value: 'Lockout', text: 'Lockout' },
                    { value: 'Other', text: 'Other' },
                    { value: 'Police Call', text: 'Police Call' },
                    { value: 'Private', text: 'Private' },
                    { value: 'Winch Out', text: 'Winch Out' },
                ],

                colorOptions: [
                    {value: 'Beige', text: 'Beige'},
                    {value: 'Black', text: 'Black'},
                    {value: 'Blue', text: 'Blue'},
                    {value: 'Bronze', text: 'Bronze'},
                    {value: 'Brown', text: 'Brown'},
                    {value: 'Burgundy', text: 'Burgundy'},
                    {value: 'Gold', text: 'Gold'},
                    {value: 'Gray', text: 'Gray'},
                    {value: 'Green', text: 'Green'},
                    {value: 'Maroon', text: 'Maroon'},
                    {value: 'Orange', text: 'Orange'},
                    {value: 'Other', text: 'Other'},
                    {value: 'Pink', text: 'Pink'},
                    {value: 'Purple', text: 'Purple'},
                    {value: 'Red', text: 'Red'},
                    {value: 'Silver', text: 'Silver'},
                    {value: 'Tan', text: 'Tan'},
                    {value: 'Teal', text: 'Teal'},
                    {value: 'White', text: 'White'},
                    {value: 'Yellow', text: 'Yellow'},
                ],

                provinceOptions: [{value: 'AB', text: 'Alberta'}, {value: 'BC', text: 'British Columbia'}, {value: 'MB', text: 'Manitoba'}, {value: 'NB', text: 'New Brunswick'}, {value: 'NL', text: 'Newfoundland and Labrador'}, {value: 'NS', text: 'Nova Scotia'}, {value: 'NT', text: 'Northwest Territories'}, {value: 'NU', text: 'Nunavut'}, {value: 'ON', text: 'Ontario'}, {value: 'PE', text: 'Prince Edward Island'}, {value: 'QC', text: 'Quebec'}, {value: 'SK', text: 'Saskatchewan'}, {value: 'YT', text: 'Yukon'}, {value: 'AL', text: 'Alabama'}, {value: 'AK', text: 'Alaska'}, {value: 'AZ', text: 'Arizona'}, {value: 'AR', text: 'Arkansas'}, {value: 'CA', text: 'California'}, {value: 'CO', text: 'Colorado'}, {value: 'CT', text: 'Connecticut'}, {value: 'DE', text: 'Delaware'}, {value: 'FL', text: 'Florida'}, {value: 'GA', text: 'Georgia'}, {value: 'HI', text: 'Hawaii'}, {value: 'ID', text: 'Idaho'}, {value: 'IL', text: 'Illinois'}, {value: 'IN', text: 'Indiana'}, {value: 'IA', text: 'Iowa'}, {value: 'KS', text: 'Kansas'}, {value: 'KY', text: 'Kentucky'}, {value: 'LA', text: 'Louisiana'}, {value: 'ME', text: 'Maine'}, {value: 'MD', text: 'Maryland'}, {value: 'MA', text: 'Massachusetts'}, {value: 'MI', text: 'Michigan'}, {value: 'MN', text: 'Minnesota'}, {value: 'MS', text: 'Mississippi'}, {value: 'MO', text: 'Missouri'}, {value: 'MT', text: 'Montana'}, {value: 'NE', text: 'Nebraska'}, {value: 'NV', text: 'Nevada'}, {value: 'NH', text: 'New Hampshire'}, {value: 'NJ', text: 'New Jersey'}, {value: 'NM', text: 'New Mexico'}, {value: 'NY', text: 'New York'}, {value: 'NC', text: 'North Carolina'}, {value: 'ND', text: 'North Dakota'}, {value: 'OH', text: 'Ohio'}, {value: 'OK', text: 'Oklahoma'}, {value: 'OR', text: 'Oregon'}, {value: 'PA', text: 'Pennsylvania'}, {value: 'RI', text: 'Rhode Island'}, {value: 'SC', text: 'South Carolina'}, {value: 'SD', text: 'South Dakota'}, {value: 'TN', text: 'Tennessee'}, {value: 'TX', text: 'Texas'}, {value: 'UT', text: 'Utah'}, {value: 'VT', text: 'Vermont'}, {value: 'VA', text: 'Virginia'}, {value: 'WA', text: 'Washington'}, {value: 'WV', text: 'West Virginia'}, {value: 'WI', text: 'Wisconsin'}, {value: 'WY', text: 'Wyoming'}, {value: 'AS', text: 'American Samoa'}, {value: 'DC', text: 'District of Columbia'}, {value: 'FM', text: 'Federated States of Micronesia'}, {value: 'GU', text: 'Guam'}, {value: 'MH', text: 'Marshall Islands'}, {value: 'MP', text: 'Northern Mariana Islands'}, {value: 'PW', text: 'Palau'}, {value: 'PR', text: 'Puerto Rico'}, {value: 'VI', text: 'Virgin Islands'}, ],

            };
        },

        mounted() {
            const province = localStorage.getItem('default-province');
            this.selectedProvince = province ? JSON.parse(province) : null;
        },

        computed: {

            vehicleMakeOptions() {
                let options = [];
                this.vehicleMakes.forEach(make => {
                    options.push({value: make.VehicleMake, text: make.VehicleMake});
                });
                return options;
            },

            vehicleModelOptions() {
                let options = [];

                const make = _.find(this.vehicleMakes, make => make.VehicleMake === this.call.VehicleMake);

                if (make) {
                    let modelFound = false;

                    make.VehicleModels.forEach(model => {
                        options.push({value: model.VehicleModel, text: model.VehicleModel});
                        modelFound = (model.VehicleModel == this.call.VehicleModel ? true : modelFound);
                    });

                    if (this.call.VehicleModel && !modelFound) {
                        options.push({value: this.call.VehicleModel, text: this.call.VehicleModel});
                    }

                }


                return options;
            },

        },

        methods: {

            vinLookup() {

                this.fieldErrors.VIN = [];

                if (!this.call.VIN) {
                    this.fieldErrors.VIN.push('Please enter a VIN number.');
                }

                if (this.fieldErrors.VIN.length) {
                    return;
                }

                notifier.asyncBlock(
                    Ajax.get('call-details/vin-lookup', { vin: this.call.VIN }),
                    this.handleVehicleLookupResponse,
                    (response) => {
                        if (response) {
                            notifier.alert('Failed to complete the plate/tag lookup.');
                        }
                    },
                    'Looking up vehicle information',
                );

            },

            changeProvince(province) {
                this.selectedProvince = province;
                localStorage.setItem('default-province', JSON.stringify(province));
            },

            plateLookup() {

                // console.log(typeof this.fieldErrors.VehiclePlate);
                // console.log(this.fieldErrors.VehiclePlate);

                this.fieldErrors.VehiclePlate = [];

                if (!this.call.VehiclePlate) {
                    this.fieldErrors.VehiclePlate.push('Please enter a plate number.');
                }
                if (this.selectedProvince == null ) {
                    this.fieldErrors.VehiclePlate.push('Please select a province.');
                }

                if (this.fieldErrors.VehiclePlate.length) {
                    return;
                }

                notifier.asyncBlock(
                    Ajax.get('call-details/plate-lookup', { plate: this.call.VehiclePlate, province: this.selectedProvince.value, }),
                    this.handleVehicleLookupResponse,
                    (response) => {
                        if (response) {
                            notifier.alert('Failed to complete the plate/tag lookup.');
                        }
                    },
                    'Looking up vehicle information',
                );

            },

            handleVehicleLookupResponse(response) {
                const data = response.data;
                if (data.Status === 0) {

                    this.call.VIN = data.VIN;
                    this.call.VehicleYear = data.VehicleYear;
                    this.call.VehicleMake = data.VehicleMake;
                    this.call.VehicleModel = data.VehicleModel;

                    this.$nextTick(() => {
                        this.call.VehicleModel = data.VehicleModel;
                    });

                    notifier.success('Found vehicle information');

                } else {
                    notifier.warning('Vehicle information not found');
                }
            },

        },

    }
</script>

